import React, { Fragment } from 'react'
import Banner from './banner/Banner'
import Coinslist from './Coinslist'
function Home() {
  return (
<Fragment>
<Banner/>
<Coinslist/>
</Fragment>
  )
}

export default Home
